// extracted by mini-css-extract-plugin
module.exports = {"notes":"BookingEngineConfigDetailsCard_notes__2GWwP","notesText":"BookingEngineConfigDetailsCard_notesText__2JFFH"};